import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetAttributeTypeListResponse } from '@/api/handlers/resources/attributeTypes/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { AttributeQueryKeys } from './attributeQueryKeys';

/** Reads the full attribute dictionary (`GET /attribute-types`). */
export const useAttributeTypesQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetAttributeTypeListResponse>>({
        queryKey: AttributeQueryKeys.list(),
        queryFn: () => apiClient.attributeTypes.getAttributeTypes(),
        enabled,
        staleTime: 60_000,
    });
};
